export default {
  apiKey: 'AIzaSyAV1TyE9WgTVVk9BuAYSh2vGEfEaj2s_IU',
  authDomain: 'pool-demo-project.firebaseapp.com',
  databaseURL: 'https://pool-demo-project.firebaseio.com',
  projectId: 'pool-demo-project',
  storageBucket: 'pool-demo-project.appspot.com'
}
// export default {
//   apiKey: 'AIzaSyCpCBd6-L9gLHBCNrmlbcSdZ8n115AiL5k',
//   authDomain: 'poolrestore-920bd.firebaseapp.com',
//   databaseURL: 'https://pool-demo-project.firebaseio.com',
//   projectId: 'poolrestore-920bd',
//   storageBucket: 'poolrestore-920bd.appspot.com'
// }



// WEBPACK FOOTER //
// ./src/firebaseConfig.js